import cx from 'classnames';

import styles from './NetworkPill.module.css';
import Pill from '../Pill/Pill';

import { ReactComponent as BitcoinSvg } from '@frontend/assets/networks/btc.svg';
import { ReactComponent as EthereumSvg } from '@frontend/assets/networks/eth.svg';
import { ReactComponent as BaseSvg } from '@frontend/assets/networks/base.svg';
import { ReactComponent as PolygonSvg } from '@frontend/assets/networks/polygon.svg';
import { ReactComponent as BscSvg } from '@frontend/assets/networks/bsc.svg';
import { ReactComponent as MultiversXSvg } from '@frontend/assets/networks/erd.svg';
import { ReactComponent as DashSvg } from '@frontend/assets/networks/dash.svg';
import { ReactComponent as LightningSvg } from '@frontend/assets/networks/ln-btc.svg';
import { ReactComponent as TronSvg } from '@frontend/assets/networks/trx.svg';
import { ReactComponent as BinancePaySvg } from '@frontend/assets/exchanges/binance.svg';
import { ReactComponent as WalletConnectPaySvg } from '@frontend/assets/networks/walletconnectpay.svg';
import { ReactComponent as SuiSvg } from '@frontend/assets/networks/sui.svg';
import { ReactComponent as SolSvg } from '@frontend/assets/networks/sol.svg';
import { ReactComponent as HederaSvg } from '@frontend/assets/networks/hedera.svg';
import { BoxStyleProps } from '../Box';

export type Network =
  | 'btc'
  | 'eth'
  | 'base'
  | 'polygon'
  | 'bsc'
  | 'erd'
  | 'dash'
  | 'sui'
  | 'hedera'
  | 'ln-btc'
  | 'trx'
  | 'binancePay'
  | 'walletConnectPay'
  | 'solanaPay'
  | 'solana';

interface NetworkPillProps extends BoxStyleProps {
  className?: string;
  network: Network;
  networkDisplayText: string;
}

export const networkData = {
  btc: {
    svgIcon: <BitcoinSvg />,
    className: styles['base--network-btc'],
  },
  eth: {
    svgIcon: <EthereumSvg />,
    className: styles['base--network-eth'],
  },
  base: {
    svgIcon: <BaseSvg />,
    className: styles['base--network-base'],
  },
  polygon: {
    svgIcon: <PolygonSvg />,
    className: styles['base--network-polygon'],
  },
  bsc: {
    svgIcon: <BscSvg />,
    className: styles['base--network-bsc'],
  },
  trx: {
    svgIcon: <TronSvg />,
    className: styles['base--network-tron'],
  },
  erd: {
    svgIcon: <MultiversXSvg />,
    className: styles['base--network-erd'],
  },
  dash: {
    svgIcon: <DashSvg />,
    className: styles['base--network-dash'],
  },
  'ln-btc': {
    svgIcon: <LightningSvg />,
    className: styles['base--network-lightning'],
  },
  binancePay: {
    svgIcon: <BinancePaySvg />,
    className: styles['base--network-binancePay'],
  },
  walletConnectPay: {
    svgIcon: <WalletConnectPaySvg />,
    className: styles['base--network-walletConnectPay'],
  },
  solanaPay: {
    svgIcon: <SolSvg />,
    className: styles['base--network-solanaPay'],
  },
  solana: {
    svgIcon: <SolSvg />,
    className: styles['base--network-solana'],
  },
  sui: {
    svgIcon: <SuiSvg />,
    className: styles['base--network-sui'],
  },
  hedera: {
    svgIcon: <HederaSvg />,
    className: styles['base--network-hedera'],
  },
};

export default function NetworkPill({
  className,
  network,
  networkDisplayText,
  ...boxStyleProps
}: NetworkPillProps): JSX.Element {
  const leftIcon = networkData[network].svgIcon;
  const networkClassName = networkData[network].className;

  return (
    <Pill
      data-test-id="network-pill"
      className={cx(styles['base'], networkClassName, className)}
      leftIcon={leftIcon}
      textClassName={styles['text']}
      text={networkDisplayText}
      {...boxStyleProps}
    />
  );
}
